import GeneralProperties from '../../core/ComponentDocs'

export default {
    documentation : {
        ...GeneralProperties.documentation,
        
        scrollToTop :{
            hintTitle: "Informação",
            hintText:"Quando definido como verdadeiro, o gatilho para mudança de página ocorrerá no topo do container. Ex: Chat"
        },
        keyFieldForScroller :{
            hintTitle: "Informação",
            hintText:"Ao definir a propriedade keyFieldForScroller, o ClicList ativa automaticamente um modo otimizado de renderização, ideal para listas com muitos dados. O valor atribuído deve existir em todos os itens da lista e a chave será usada para identificar cada linha de forma única."
        },

        // items               :{
        //     hintTitle: "",
        //     hintText:""
        // },
            
    }
}